import { Injectable } from '@angular/core';
import { CrudService } from '@core/api';
import { FileInfo } from '../models';
// Known leak, ratcheted rather than excused: this value import puts
// DevExtreme's runtime in the NativeScript bundle, measured at 1.53 MiB (9.3%
// of vendor.js) in docs/analysis/mobile-bundle-devextreme-leak.md. The rule errors on
// any NEW devextreme import here; removing these eight disables is what fixing
// that leak means.
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  constructor(private crud: CrudService) {}

  public rotateImage(fileId: number, direction: 'left' | 'right') {
    return this.crud
      .updateOne(`api/filemanager/rotateImage`, fileId, { direction })
      .pipe(
        catchError((e) => {
          notify(e.message, 'error');
          return of(e);
        })
      );
  }
}
